import React, { Component } from 'react'
import { Button, Grid, Cell } from 'react-md'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

import { Recaptcha, TextField } from 'components'
import { email, minLength } from 'lib/validation'
import * as actions from 'redux/actions'
import * as routes from 'routes'

import ForgotPassword from './ForgotPassword'

import './index.css'

const minLength8 = minLength(8)

class SignIn extends Component {
  constructor (props) {
    super(props)
    this.onForgotPasswordClick = this.onForgotPasswordClick.bind(this)
    this.onSendResetInstructions = this.onSendResetInstructions.bind(this)
  }

  onForgotPasswordClick () {
    const { history } = this.props
    history.push(routes.forgotPassword())
  }

  async onSendResetInstructions (data) {
    const { sendResetInstructions, history } = this.props
    const response = await sendResetInstructions(data.email, data.captcha)

    this._recaptchaForgotPassword.reset()

    if (response.errors) {
      throw new SubmissionError(response.errors)
    }

    history.push(routes.signIn())
  }

  render () {
    const { form, handleSubmit, location, recaptchaRef } = this.props
    return (
      <div>
        <ForgotPassword
          visible={location.hash === '#forgot-password'}
          onSubmit={this.onSendResetInstructions}
          recaptchaRef={e => { this._recaptchaForgotPassword = e }}
        />
        <form onSubmit={handleSubmit}>
          <Grid>
            <Cell size={12}>
              <Field
                id={`${form}-email`}
                name='email'
                label='Email'
                component={TextField}
                validate={[ email ]}
                required
              />
            </Cell>
            <Cell size={12}>
              <Field
                id={`${form}-password`}
                name='password'
                label='Password'
                type='password'
                component={TextField}
                validate={[ minLength8 ]}
                required
              />
              <div className='forgot-password-button'>
                <Link to={routes.forgotPassword()}>Forgot your password?</Link>
              </div>
            </Cell>
            <Cell size={12} className='captcha'>
              <Field
                id={`${form}-captcha`}
                name='captcha'
                component={Recaptcha}
                inputRef={recaptchaRef}
              />
            </Cell>
            <Cell size={12} className='md-text-center'>
              <Button
                type='submit'
                flat
                primary
                swapTheming
                className='join-button'
              >
                Login
              </Button>
            </Cell>
          </Grid>
          <button type='submit' style={{display: 'none'}} />
        </form>
      </div>
    )
  }
}

const SignInForm = reduxForm({
  form: 'signin'
})(SignIn)

export default withRouter(connect(null, actions)(SignInForm))



// WEBPACK FOOTER //
// ./src/containers/Home/SignIn/index.js